import { pagesFrom } from '@shared-ui/app-pages';

/**
 * Every page past the front door comes from this one lazily loaded chunk (see
 * appPages.ts): a visitor to the landing page or the sign-in screen does not
 * download them. The sign-in screen calls `page.preload()`.
 */
export const page = pagesFrom(() => import('./appPages'));
